import { AuthXInterceptor } from '../Config/AuthXInterceptor'
import type { ApiEnvelope } from './stationStaffService'

export type StationAttendantFillingStation = {
  id: string
  businessName: string
  branchName: string
  address: string
  state: string
  city: string
}

export type StationAttendant = {
  resourceId: string
  firstName: string
  lastName: string
  email: string
  phone: string
  country: string
  referralCode: string
  isPasswordUpdated: boolean
  disabledAt: string | null
  lastLoginAt: string | null
  createdAt: string
  fillingStation: StationAttendantFillingStation | null
  role?: 'Attendant' | 'Associate' | 'Manager'
}

export type StationAttendantBankInfo = {
  bankCode: string
  bankName: string
  bankAccountNumber: string
  bankAccountName: string
}

export type StationAttendantDetails = StationAttendant & {
  emailVerifiedAt: string | null
  totalEarnedMajor: number
  totalWithdrawnMajor: number
  availableMajor: number
  pendingWithdrawalMajor: number
  totalReferrals: number
  completedReferrals: number
  currency: string
  currencySymbol: string
  bankInfo: StationAttendantBankInfo | null
}

export type StationAttendantsStats = {
  totalCompletedWithdrawalMajor: number
  totalPendingWithdrawalMajor: number
  totalEarningsPaidOutMajor: number
  totalAttendants: number
  totalAssociates?: number
  totalManagers?: number
}

export type CreateStationAttendantPayload = {
  firstName: string
  lastName: string
  email: string
  country: string
  phone: string
  fillingStationId: string
}

export type StationAttendantReferral = {
  resourceId: string
  status: string
  referrer: {
    resourceId: string
    firstName: string
    lastName: string
    email: string
    phone: string
  }
  referred: {
    resourceId: string
    firstName: string
    lastName: string
    email: string
    phone: string
  }
  referrerRewardMinor: number
  referredRewardMinor: number
  referrerBonusPercentage: number
  welcomeBonusPercentage: number
  completedAt: string | null
  createdAt: string
}

export const stationAttendantsBXService = {
  list: async (params: {
    page: number
    limit: number
    sortOrder: 'ASC' | 'DESC'
    search?: string
    disabled?: string
  }) => {
    if (params.disabled === '') {
      delete params.disabled
    }

    return AuthXInterceptor.get<ApiEnvelope<StationAttendant[]>>('station-attendants', { params })
  },

  stats: async () => {
    return AuthXInterceptor.get('station-attendants/stats')
  },

  create: async (payload: CreateStationAttendantPayload) => {
    return AuthXInterceptor.post('station-attendants', payload)
  },

  show: async (id: string) => {
    return AuthXInterceptor.get(`station-attendants/${encodeURIComponent(id)}`)
  },

  referrals: async (id: string, params: { page: number; limit?: number }) => {
    return AuthXInterceptor.get(`station-attendants/${encodeURIComponent(id)}/referrals`, {
      params,
    })
  },
}
